import { AddCreditCard } from 'credit-cards'
import { setAuthFormState } from 'login-and-signup/actions'
import { AUTH_CONTAINER_STATE_SUCCESS } from 'login-and-signup/constants'
import Button from 'shared/components/Button'

const CardsContainer = ({ setAuthFormState }) => {
    const skipHandler = () => {
        setAuthFormState(AUTH_CONTAINER_STATE_SUCCESS)
    }

    return (
        <div className="container header-cards-container">
            <div className="header-form">
                <legend>
                    <T>dashboard.label.add.credit.card</T>
                </legend>
                <AddCreditCard shouldShowInfo={false} />
                <Button btnStyle="link" size="small" iconRight="next" className="ml-auto mt-3" onClick={skipHandler}>
                    <T>dashboard.cards.skip.btn.label</T>
                </Button>
            </div>
        </div>
    )
}

export default compose(
    connect(undefined, {
        setAuthFormState,
    })
)(CardsContainer)
